export const fileListItem = (name, size, removeIconAttributes) =>
  `<li><div class='d-flex align-items-center bg-top-gray rounded mb-1 py-1 px-3'><div>${name
  } (${Math.ceil(
    size / 1024
  )}kB)</div><div class='ms-auto'><img src='/icons/cross.svg' height='12' ${removeIconAttributes} class='cursor-pointer'></div></div></li>`;